import React from 'react';

export const NotificationsBellIcon = () => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M12 6.43945V9.76945'
            stroke='#475467'
            stroke-width='2'
            stroke-miterlimit='10'
            stroke-linecap='round'
        />
        <path
            d='M12.0199 2C8.3399 2 5.3599 4.98 5.3599 8.66V10.76C5.3599 11.44 5.0799 12.46 4.7299 13.04L3.4599 15.16C2.6799 16.47 3.2199 17.93 4.6599 18.41C9.4399 20 14.6099 20 19.3899 18.41C20.7399 17.96 21.3199 16.38 20.5899 15.16L19.3199 13.04C18.9699 12.46 18.6899 11.43 18.6899 10.76V8.66C18.6799 5 15.6799 2 12.0199 2Z'
            stroke='#475467'
            stroke-width='2'
            stroke-miterlimit='10'
            stroke-linecap='round'
        />
        <path
            d='M15.3299 18.8203C15.3299 20.6503 13.8299 22.1503 11.9999 22.1503C11.0899 22.1503 10.2499 21.7703 9.64992 21.1703C9.04992 20.5703 8.66992 19.7303 8.66992 18.8203'
            stroke='#475467'
            stroke-width='2'
            stroke-miterlimit='10'
        />
    </svg>
);
